import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Seo } from "@/components/seo/Seo";
import { useI18n } from "@/i18n/I18nProvider";

const NotFound = () => {
  const location = useLocation();
  const { t } = useI18n();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <Seo title={t('notfound.seo_title', 'Page Not Found | Halomora')} noindex canonicalPath="/404" />
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">{t('notfound.heading', '404')}</h1>
        <p className="text-xl text-gray-600 mb-4">{t('notfound.message', 'Oops! Page not found')}</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          {t('notfound.back_home', 'Return to Home')}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
